<p> {{ err }}</p>
<p *ngIf="isVerifying">one moment while we verify your phone number</p>
<form *ngIf="!isVerifying" [formGroup]="phoneVerificationForm" autocomplete="off" novalidate (ngSubmit)="verifyPhone(phoneVerificationForm.value)">
	<label>type in your phone verification code</label>
		<input class="roundBorders lighter-background input-styling" formControlName="phoneVerificationCode" id="phoneVerificationCode" type="text" placeholder="phoneVerificationCode">
	<button type="sub" class="btn btn-info btn-lg">verify phone</button>
</form>